import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="matrix(-1 0 0 1 20 1)"
      >
        <circle
          cx="9.5"
          cy="9.5"
          r="9.5"
          stroke="#35C974"
          strokeWidth="0.8"
        ></circle>
        <g fill="#35C974">
          <path
            d="M2.851 8.256c-.588 0-1.065.49-1.065 1.08 0 .574.463 1.078 1.065 1.078.603 0 1.08-.504 1.08-1.079 0-.588-.491-1.079-1.08-1.079zM3.034.087C1.142.087.273 1.207.273 1.964c0 .547.462.8.84.8.757 0 .45-1.08 1.879-1.08.7 0 1.26.308 1.26.953 0 .757-.784 1.191-1.246 1.584-.407.35-.94.924-.94 2.13 0 .728.197.938.771.938.687 0 .827-.308.827-.574 0-.729.014-1.15.785-1.752.378-.294 1.57-1.247 1.57-2.564S4.826.087 3.033.087z"
            transform="translate(6.333 4.75)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
